import { useEffect, useState } from 'react';
import { apiClient } from '../../utils/api';

export function useSuggestions({ enabled = true } = {}) {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(() => {
        if (!enabled) return;
        apiClient
            .getSuggestions()
            .then((data) => setSuggestions(data || []))
            .catch((err) => console.error('[chat] getSuggestions failed', err));
    }, [enabled]);

    return { suggestions, setSuggestions, showSuggestions, setShowSuggestions };
}
